import React, { useEffect } from "react";
import { logout } from "../../api/axios";
import { clearLocalDataKeepingAccount } from "../../store/accountStore";

const AutoLogout: React.FC = () => {
  useEffect(() => {
    const doLogout = async () => {
      try {
        await logout();
      } catch (error) {
        console.error("Logout failed:", error);
      } finally {
        clearLocalDataKeepingAccount();
        window.location.reload();
      }
    };

    doLogout();
  }, []);

  return null;
};

export default AutoLogout;
